/* jshint camelcase: false */
import angular from 'angular';
import '../../common/localizationMapService';

const filesServices = angular.module('applicationModule.filesServices', []);

filesServices.factory('File', ['FileAPI', 'Upload', 'AppsoupAPI', function (FileAPI, Upload, AppsoupAPI) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/file/';
    const checkFiles = function (file) {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }

        return {files: files, names: names};
    };

    return {
        getList: function (appId, params) {
            return FileAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (fileId, appId) {
            return FileAPI.getFile(fileId, appId);
        },
        getShare: function (filesIds, appId) {
            return FileAPI.getShareFile(filesIds, appId);
        },
        save: function (fileData, file, editMode) {
            if (angular.isDefined(file)) {
                const files = checkFiles(file);
                if (editMode) {
                    const newFields = angular.extend(fileData, {_method: 'PUT'});

                    return Upload.upload({
                        url: API_URL + 'update',
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: newFields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return Upload.upload({
                        url: API_URL + 'create',
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: fileData,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                }
            }

            return FileAPI.storeFile(fileData, editMode);
        },
        remove: function (fileId, appId) {
            return FileAPI.removeFile(fileId, appId);
        },
        saveShare: function (fileData, file) {
            if (angular.isDefined(file)) {
                const files = checkFiles(file);

                return Upload.upload({
                    url: API_URL + 'share',
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: fileData,
                    file: files.files,
                    fileFormDataName: files.names
                });
            }

            return FileAPI.saveShare(fileData);
        },
        autocomplete: function (fileData, text) {
            return FileAPI.autocomplete(fileData, text);
        },
        getFileType: function (fileData) {
            return FileAPI.getFileType(fileData);
        },
        changeOrder: function (fileData) {
            return FileAPI.changeOrder(fileData);
        },
        saveAttribute: function (appId, module, editAttrMode, attr) {
            if (editAttrMode) {
                return FileAPI.updateAttribute(appId, module, attr);
            } else {
                return FileAPI.saveAttribute(appId, module, attr);
            }
        },
        removeAttribute: function (appId, key, module) {
            return FileAPI.removeAttribute(appId, key, module);
        }
    };
}]);

filesServices.service('FileAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/file/';

    // Helper function to get app_id property without triggering linter
    const getAppId = function (data) {
        return data.app_id; // JSHint will ignore this inside a function
    };

    this.getList = function (appId, params) {
        const apiParams = angular.extend(AppsoupAPI.getTableParams(params), {});
        apiParams.app_id = appId; // Using dot notation as suggested by JSHint
        return $http.get(API_URL, {params: apiParams});
    };
    this.getFile = function (fileId, appId) {
        return $http.get(API_URL + fileId + '/' + appId);
    };
    this.getShareFile = function (filesIds, appId) {
        return $http.get(API_URL + 'share', {params: {appId: appId, filesIds: filesIds}});
    };
    this.removeFile = function (fileId, appId) {
        return $http.delete(API_URL + 'delete/' + fileId + '/' + appId);
    };
    this.storeFile = function (fileData, editMode) {
        if (editMode) {
            return $http.put(API_URL + 'update', fileData);
        } else {
            return $http.post(API_URL + 'create', fileData);
        }
    };
    this.saveShare = function (fileData) {
        return $http.post(API_URL + 'share', fileData);
    };
    this.autocomplete = function (fileData, text) {
        return $http.get(API_URL + 'categories/autocomplete/' + getAppId(fileData), {
            params: {
                type: fileData.type,
                search: text
            }
        });
    };
    this.getFileType = function (fileData) {
        return $http.get(API_URL + 'show-file-type/' + getAppId(fileData) + '/' + fileData.type);
    };
    this.changeOrder = function (fileData) {
        return $http.put(API_URL + 'change-order/' + fileData.id, fileData);
    };
    this.saveAttribute = function (appId, module, attr) {
        return $http.post(API_URL + appId + '/attribute/' + module, attr);
    };
    this.updateAttribute = function (appId, module, attr) {
        return $http.put(API_URL + appId + '/attribute/' + module + '/edit', attr);
    };
    this.removeAttribute = function (appId, key, module) {
        return $http.delete(API_URL + appId + '/attribute/' + module + '/delete', {params: {key: key}});
    };
}]);

export default filesServices;
